import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary } from '@a-type/ui';
export function withErrorBoundary(Component, fallback = null) {
    return function WithErrorBoundary(props) {
        return (_jsx(ErrorBoundary, { fallback: fallback?.(props), children: _jsx(Component, { ...props }) }));
    };
}
//# sourceMappingURL=withErrorBoundary.js.map